import React, { useState, useEffect } from 'react'
import { Card, Row, Col, Button, DatePicker, Modal, Checkbox } from 'antd'
import { WeightText } from './styles'
import FilterButtonGroup from '../FilterButtonGroup'
import moment from 'moment'

const { RangePicker } = DatePicker

function WeightValueCard(props) {
  const [visible, setVisible] = useState(false)
  const [startDate, setStartDate] = useState(false)
  const [endDate, setEndDate] = useState(false)
  const [checkAll, setCheckAll] = useState(false)
  const { min, max, average } = props.values
  const { filterReport, filterByLevelAndDate, checkAllWeights } = props

  useEffect(() => {
    setCheckAll(checkAllWeights)
  }, [checkAllWeights])

  const validDate = (date) => {
    return moment(date).isValid(date) ? moment(date) : null
  }

  const onDateChange = (value, dateString, checked) => {
    if (checked) {
      setStartDate(false)
      setEndDate(false)
    } else {
      setStartDate(dateString[0] || null)
      setEndDate(dateString[1] || null)
    }
    setCheckAll(checked)
  }

  const handleOk = () => {
    filterReport(startDate, endDate, checkAll)
    setVisible(false)
  }

  return (
    <Card
      title={
        <Row justify="space-between">
          <Col span={4}>น้ำหนัก</Col>
          {filterReport && (
            <Col span={20} className="d-flex justify-content-end">
              <FilterButtonGroup filterByLevelAndDate={filterByLevelAndDate} bmi={true} checkAll={checkAllWeights} />
              <Button type="primary" onClick={() => setVisible(true)}>
                เลือกช่วงวันที่ ที่ต้องการแสดงผล
              </Button>
            </Col>
          )}
        </Row>
      }
    >
      <Modal title="เลือกช่วงวันที่ ที่ต้องการแสดงผล" visible={visible} onOk={handleOk} onCancel={() => setVisible(false)}>
        <Row align="middle">
          <RangePicker className="mr-3" format="DD MMM YYYY" value={[validDate(startDate), validDate(endDate)]} onChange={onDateChange} />
          <Checkbox checked={checkAll} onChange={(e) => onDateChange(false, false, e.target.checked)}>
            แสดงทั้งหมด
          </Checkbox>
        </Row>
      </Modal>
      <Row>
        <WeightText color="#76c9d4" span={8}>
          ค่าน้ำหนักต่ำสุด
        </WeightText>
        <WeightText color="#76c9d4" span={8}>
          ค่าน้ำหนักสูงสุด
        </WeightText>
        <WeightText color="#76c9d4" span={8}>
          ค่าน้ำหนักเฉลี่ย
        </WeightText>
        <WeightText color="blue" span={8}>
          {Math.ceil(min)}
        </WeightText>
        <WeightText color="red" span={8}>
          {Math.ceil(max)}
        </WeightText>
        <WeightText color="black" span={8}>
          {Math.ceil(average)}
        </WeightText>
      </Row>
    </Card>
  )
}

export default WeightValueCard
